import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Получить код локали
 */
export const getLocaleCode = () => {
  const fromCookies = cookies.get('locale');
  if (fromCookies) {
    return fromCookies;
  }
  return null;
};

/**
 * Установить код локали
 */
export const setLocaleCode = localeCode => {
  if (localeCode) {
    return cookies.set('locale', localeCode, { path: '/' });
  }
  return cookies.remove('locale', { path: '/' });
};

export default null;



// WEBPACK FOOTER //
// ./src/utils/localeHalper.js